module.exports = __webpack_public_path__ + "static/frontUserNew/img/inner-list04.752bc396.png";